/**
 * @file 教师列表筛选字段
 * @description RequestTable searchForm.items：名称、账号、状态。
 *
 * @whenToUse 仅教师管理 RequestTable。
 * @whenNotToUse 其他业务筛选。
 */

import { Input } from '@/components/ui/input.tsx'
import type { RequestTableSearchContext } from '@/components/ui/request-table.tsx'
import { Select } from '@/components/ui/select.tsx'
import type { TeacherQuery } from '@/components/pages/teacher-page/types.ts'

const STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '启用' },
  { value: '0', label: '禁用' },
]

/**
 * 教师列表搜索表单项
 */
export function TeacherSearchFields({
  values,
  setField,
}: RequestTableSearchContext<TeacherQuery>) {
  return (
    <>
      <Input
        value={values.teacherName}
        placeholder="教师名称"
        onChange={(event) => setField('teacherName', event.target.value)}
      />
      <Input
        value={values.userName}
        placeholder="教师账号"
        onChange={(event) => setField('userName', event.target.value)}
      />
      <Select
        value={values.status}
        placeholder="全部"
        options={STATUS_OPTIONS}
        onChange={(value) => setField('status', value)}
      />
    </>
  )
}
